import type { ChangeEvent } from 'react'

import { FieldLabelWrapper } from "/app/libraries/arcana/src/blocks/AuthFormBox/index.ts"
import { LoginUsernameInputBlock } from "/app/libraries/arcana/src/blocks/InputBlock/Templates/index.ts"
import { TextBoxCaption3Secondary } from "/app/libraries/arcana/src/atoms/TextBox/Templates/index.ts"

import { useForm } from 'effector-forms'
import { useUnit } from 'effector-react'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { translations, model as verifyModel } from '../model'

export interface VerifyCodeInputProps {
  liveTo?: string | null
}

export const VerifyCodeInput = ({ liveTo }: VerifyCodeInputProps) => {
  const { t } = useTranslation()
  const permanentError = useUnit(verifyModel.$permError)
  const locked = useUnit(verifyModel.$locked)
  const pending = useUnit(verifyModel.confirmCodeRegistrationFx.pending)
  const formTranslations = useUnit(translations.$inputVerifyFormTranslation)
  const { fields, hasError, errorText } = useForm(verifyModel.confirmForm)
  const isInputDisabled =
    pending || liveTo === null || locked || Boolean(permanentError)

  const getErrorMessage = hasError('code')
    ? errorText('code', formTranslations.errors)
    : ''

  const codeExpiredTitle =
    liveTo === null
      ? formTranslations.codeExpired
      : t('email_code_expiration_time_web', {
          time: liveTo,
        })

  const handleChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) =>
      /^\d*$/.test(e.target.value) && // do not allow to type anything except numbers
      fields.code.onChange(e.target.value),
    [fields.code]
  )

  const expiredTitle = locked || permanentError ? '\xA0' : codeExpiredTitle

  return (
    <FieldLabelWrapper>
      <LoginUsernameInputBlock
        value={fields.code.value}
        placeholder={formTranslations.placeholder}
        label={formTranslations.label}
        disabled={isInputDisabled}
        onChange={handleChange}
        errorMessage={getErrorMessage}
        autoComplete='one-time-code'
      />
      {liveTo !== undefined && (
        <TextBoxCaption3Secondary title={expiredTitle} />
      )}
    </FieldLabelWrapper>
  )
}
